<script>
  // Thin Svelte shell around the framework-free dither3d engine: it owns the
  // canvas element and the scene lifecycle, and forwards `progress` (0..1).
  import { createDitherScene } from './dither3d.js';

  let {
    progress = 0,
    mask = null,
    thresholdMap = 'voidcluster',
    cols = 72,
    rows = 72,
    centerY = 0.5,
    reducedMotion = false,
  } = $props();

  let canvas;
  let scene = $state(null);

  $effect(() => {
    const reduced =
      reducedMotion ||
      (typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches);
    const s = createDitherScene(canvas, {
      mask,
      thresholdMap,
      cols,
      rows,
      centerY,
      reducedMotion: reduced,
    });
    scene = s;
    return () => {
      s.destroy();
      scene = null;
    };
  });

  $effect(() => {
    scene?.setProgress(progress);
  });
</script>

<canvas bind:this={canvas} class="dither-stage" aria-hidden="true"></canvas>

<style>
  .dither-stage {
    display: block;
    width: 100%;
    height: 100%;
    image-rendering: pixelated;
    image-rendering: crisp-edges;
  }
</style>
